import styleScriptsGlobal from './styleScriptsGlobal';
import { Z_INDEX_MAX, WHITE, BRAND_BLACK, INACTIVE_GRAY, NATIONAL_TWO_REGULAR } from './constants';

const HEADER_STYLES = {
  desktop: {
    height: '100px',
    backgroundColor: WHITE,
    width: '100%',
    display: 'flex',
    overflowX: 'hidden',
  },
  mobile: {
    height: '45px',
  },
};

const START_ORDER_STYLES = {
  desktop: {
    display: 'flex',
    backgroundColor: BRAND_BLACK,
    height: '68px',
  },
  mobile: {
    height: '100px',
    display: 'flex',
    width: '100%',
    bottom: '0',
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '1px',
    padding: '5px',
  },
};

const START_ORDER_BTN_STYLES = {
  desktop: {
    border: '1.5px solid rgb(228, 0, 43)',
    fontFamily: NATIONAL_TWO_REGULAR,
    lineHeight: '24px',
    fontSize: '14px',
    fontWeight: 500,
  },
  mobile: {
    marginTop: '16px',
    width: '75%',
    marginBottom: '21px',
  },
};

const DISPOSITION_BAR_STYLES = {
  desktop: {
    display: 'flex',
    backgroundColor: BRAND_BLACK,
    height: '68px',
  },
  mobile: {
    height: '68px',
    display: 'flex',
    width: '100%',
    bottom: '0',
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '1px',
    padding: '7px 20px',
  },
};

const FOOTER_STYLES = {
  mobile: {
    paddingBottom: '10%',
  },
};

const STICKY_TOP_VALUES = {
  desktop: {
    topLocalized: HEADER_STYLES.desktop.height, //addPixelValues(HEADER_STYLES.desktop.height, DISPOSITION_BAR_STYLES.desktop.height),
    topNonLocalized: HEADER_STYLES.desktop.height, //addPixelValues(HEADER_STYLES.desktop.height, START_ORDER_STYLES.desktop.height),
  },
  mobile: {
    topLocalized: HEADER_STYLES.mobile.height,
    topNonLocalized: HEADER_STYLES.mobile.height, //addPixelValues(HEADER_STYLES.mobile.height, START_ORDER_STYLES.mobile.height),
  },
};

const MENU_CATEGORY_STYLES_DESKTOP = {
  desktop: {
    height: '100vh',
    width: '18vw',
    position: 'sticky',
    marginLeft: '0.8%',
    top: STICKY_TOP_VALUES.desktop.topNonLocalized,
  },
};

const MENU_CATEGORY_STYLES_MOBILE = {
  mobile: {
    flexWrap: 'nowrap !important',
    marginLeft: '0 !important',
    paddingLeft: '10px',
    paddingTop: '5px',
    borderBottom: `1px solid ${INACTIVE_GRAY}`,
    overflowY: 'hidden',
    zIndex: `${Z_INDEX_MAX - 1}`,
    width: '100%',
    backgroundColor: WHITE,
    marginTop: '0',
    marginBottom: '5px',
  },
};

const defaultExports = {
  ...styleScriptsGlobal,
  HEADER_STYLES,
  START_ORDER_STYLES,
  START_ORDER_BTN_STYLES,
  DISPOSITION_BAR_STYLES,
  FOOTER_STYLES,
  STICKY_TOP_VALUES,
  MENU_CATEGORY_STYLES_DESKTOP,
  MENU_CATEGORY_STYLES_MOBILE,
};

export default defaultExports;
